module.exports = __webpack_public_path__ + "img/bell-icon.f39f04b6.svg";